import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=1b9b6153&scoped=true&"
import script from "./sendMsg.vue?vue&type=script&lang=js&"
export * from "./sendMsg.vue?vue&type=script&lang=js&"
import style0 from "./sendMsg.vue?vue&type=style&index=0&id=1b9b6153&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b6153",
  null
  
)

export default component.exports